var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33CCCC"
    },
    d: "M256,267.376c-73.716,0-133.688-59.972-133.688-133.688S182.284,0,256,0    s133.688,59.972,133.688,133.688S329.716,267.376,256,267.376z M256,22c-61.585,0-111.688,50.103-111.688,111.688    S194.415,245.376,256,245.376s111.688-50.103,111.688-111.688S317.585,22,256,22z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245,266.92V501c0,6.075,4.925,11,11,11s11-4.925,11-11V266.92c-3.629,0.297-7.296,0.456-11,0.456   S248.629,267.217,245,266.92z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.908ec4ac7ea1d98f90e615499be48f71.svg";
export { ForwardRef as ReactComponent };